import { render, staticRenderFns } from "./ProductDeliveryDescription.vue?vue&type=template&id=29687e9b&scoped=true&"
import script from "./ProductDeliveryDescription.vue?vue&type=script&lang=js&"
export * from "./ProductDeliveryDescription.vue?vue&type=script&lang=js&"
import style0 from "./ProductDeliveryDescription.vue?vue&type=style&index=0&id=29687e9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29687e9b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
